export default __webpack_public_path__ + "static/media/image2.5325b2ed.png";